import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/gift-cards";

export default class GiftCards extends Page {
  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
    this.getApp().updateWindowTitle(
      `Gift Cards | ${this.ucfirst("window-title")}`,
    );
  }
}
